<p class="ntc-hint" *ngIf="!levels().length">No levels to configure yet.</p>

<div class="ntc-level" *ngFor="let level of levels(); trackBy: trackLevel">
  <div class="ntc-level-head">
    <strong>Level {{ level.index + 1 }}</strong>
    <button type="button" class="ntc-icon" (click)="resetLevel(level.index)" matTooltip="Reset this level" aria-label="Reset level">
      <mat-icon>restart_alt</mat-icon>
    </button>
  </div>

  <label class="ntc-field" *ngIf="level.index > 0">
    <span>Title</span>
    <input type="text" [value]="level.title" (change)="setLevelTitle(level.index, $any($event.target).value)" />
  </label>

  <app-design-column-navigation [contextKey]="contextKey() + '/' + level.index" [columns]="level.columns" [expandedField]="expandedLinkField(level.index)" (activeChange)="expandLink(level.index, $event)" (configChange)="setCellConfig(level.index, $event.field, $event.config)"></app-design-column-navigation>

  <div class="ntc-column" *ngFor="let column of level.columns; let first = first; let last = last; trackBy: trackColumn"
    [class.is-hidden]="column.hidden">
    <div class="ntc-row">
      <input
        type="checkbox"
        [checked]="!column.hidden"
        (change)="setColumn(level.index, column.field, { hidden: !$any($event.target).checked })"
        [attr.aria-label]="'Show ' + column.label"
        matTooltip="Show column"
      />
      <input
        class="ntc-label"
        type="text"
        [value]="column.label"
        (change)="setText(level.index, column.field, 'label', $any($event.target).value)"
        [attr.aria-label]="'Header for ' + column.field"
      />
      <button type="button" class="ntc-icon" [disabled]="first" (click)="move(level.index, column.field, -1)" aria-label="Move up">
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button type="button" class="ntc-icon" [disabled]="last" (click)="move(level.index, column.field, 1)" aria-label="Move down">
        <mat-icon>arrow_downward</mat-icon>
      </button>
      <label class="ntc-currency" matTooltip="Convert currency: shown × the rate selected in the Currency exchange dropdown">
        <input type="checkbox" [checked]="!!(column.convertCurrency ?? column.cellConfig?.convertCurrency)"
          (change)="setColumn(level.index, column.field, { convertCurrency: $any($event.target).checked })"
          [attr.aria-label]="'Convert currency for ' + column.label" />
        <span>$↔</span>
      </label>
      <button type="button" class="ntc-icon" (click)="toggleOpen(level.index, column.field)"
        [attr.aria-expanded]="isOpen(level.index, column.field)" aria-label="Column settings">
        <mat-icon>{{ isOpen(level.index, column.field) ? 'expand_less' : 'tune' }}</mat-icon>
      </button>
    </div>

    <div class="ntc-details" *ngIf="isOpen(level.index, column.field)">
      <small class="ntc-field-key">field: {{ column.field }}<ng-container *ngIf="column.secondField"> + {{ column.secondField }}</ng-container></small>

      <!-- One column from two row keys ("6% - 10%"): the second key's value is
           drawn in this cell after the separator (its own column stays hidden). -->
      <div class="ntc-grid">
        <label class="ntc-field">
          <span>Second field</span>
          <input type="text" [value]="column.secondField ?? ''" placeholder="None" (change)="setText(level.index, column.field, 'secondField', $any($event.target).value)" />
        </label>
        <label class="ntc-field" *ngIf="column.secondField">
          <span>Separator</span>
          <input type="text" [value]="column.separator ?? ''" placeholder="-" (change)="setText(level.index, column.field, 'separator', $any($event.target).value)" />
        </label>
      </div>

      <label class="ntc-field">
        <span>Type</span>
        <select (change)="setColumn(level.index, column.field, { type: $any($event.target).value })">
          <option *ngFor="let type of cellTypes" [value]="type.value" [selected]="(column.type || 'text') === type.value">{{ type.label }}</option>
        </select>
      </label>

      <label class="ntc-field">
        <span>Align</span>
        <select (change)="setColumn(level.index, column.field, { align: $any($event.target).value })">
          <option value="left" [selected]="(column.align || 'left') === 'left'">Left</option>
          <option value="center" [selected]="column.align === 'center'">Center</option>
          <option value="right" [selected]="column.align === 'right'">Right</option>
        </select>
      </label>

      <div class="ntc-grid">
        <label class="ntc-field">
          <span>Prefix</span>
          <input type="text" [value]="column.prefix ?? ''" (change)="setText(level.index, column.field, 'prefix', $any($event.target).value)" />
        </label>
        <label class="ntc-field">
          <span>Suffix</span>
          <input type="text" [value]="column.suffix ?? ''" (change)="setText(level.index, column.field, 'suffix', $any($event.target).value)" />
        </label>
        <label class="ntc-field">
          <span>Decimals</span>
          <input type="number" min="0" max="6" [value]="column.decimals ?? ''" (change)="setNumber(level.index, column.field, 'decimals', $any($event.target).value)" />
        </label>
        <label class="ntc-field">
          <span>Width</span>
          <input type="number" min="40" [value]="column.width ?? ''" (change)="setNumber(level.index, column.field, 'width', $any($event.target).value)" />
        </label>
      </div>

      <label class="ntc-field">
        <span>Text colour</span>
        <span class="ntc-color">
          <input type="color" [value]="column.color || '#101828'" (change)="setColumn(level.index, column.field, { color: $any($event.target).value })" />
          <button type="button" class="ntc-link" *ngIf="column.color" (click)="setColumn(level.index, column.field, { color: undefined })">Clear</button>
        </span>
      </label>

      <div class="ntc-toggles">
        <label><input type="checkbox" [checked]="!!column.bold" (change)="setColumn(level.index, column.field, { bold: $any($event.target).checked })" /> Bold</label>
        <label><input type="checkbox" [checked]="!!column.mono" (change)="setColumn(level.index, column.field, { mono: $any($event.target).checked })" /> Monospace</label>
        <label *ngIf="hasEditor(column)"><input type="checkbox" [checked]="!!column.required" (change)="setColumn(level.index, column.field, { required: $any($event.target).checked })" /> Required</label>
      </div>

      <label class="ntc-field" *ngIf="hasEditor(column)">
        <span>Placeholder</span>
        <input type="text" [value]="column.placeholder ?? ''" (change)="setText(level.index, column.field, 'placeholder', $any($event.target).value)" />
      </label>

      <label class="ntc-field" *ngIf="column.type === 'dropdown'">
        <span>Options (comma separated)</span>
        <input type="text" [value]="optionsText(column)" (change)="setOptions(level.index, column.field, $any($event.target).value)" />
      </label>

      <!-- GENERIC cell configuration — the ONE editor shared with the Table &
           Matrix columns and the Drill-Down measures: display kind, colours,
           conditional rules, highlight, tooltip, dropdown values. -->
      <app-table-cell-config-editor
        title="Cell formatting" [showNavigation]="false"
        [config]="column.cellConfig"
        [fields]="levelFields(level)"
        [values]="level.values[column.field]"
        [showEditor]="true"
        [showOptions]="column.type === 'dropdown' || column.cellConfig?.editor === 'dropdown'"
        [valueKind]="column.type === 'number' || column.type === 'currency' || column.type === 'percent' ? 'number' : 'text'"
        (configChange)="setCellConfig(level.index, column.field, $event)"
      ></app-table-cell-config-editor>
      <app-design-cell-buttons
        [buttons]="column.cellConfig?.buttons ?? []"
        [context]="buttonContext()"
        [tableName]="tableName()"
        (buttonsChange)="setCellButtons(level.index, column, $event)"
      ></app-design-cell-buttons>

      <label class="ntc-field">
        <span>Empty value</span>
        <input type="text" [value]="column.emptyText ?? ''" placeholder="—" (change)="setText(level.index, column.field, 'emptyText', $any($event.target).value)" />
      </label>

      <button type="button" class="ntc-link" *ngIf="isOverridden(level.index, column.field)" (click)="resetColumn(level.index, column.field)">
        Reset column
      </button>
    </div>
  </div>
</div>
